__turbopack_context__.v({
  "button": "GuidedTour-module__pyzSNW__button",
  "card": "GuidedTour-module__pyzSNW__card",
  "copy": "GuidedTour-module__pyzSNW__copy",
  "counter": "GuidedTour-module__pyzSNW__counter",
  "dialog": "GuidedTour-module__pyzSNW__dialog",
  "footer": "GuidedTour-module__pyzSNW__footer",
  "heading": "GuidedTour-module__pyzSNW__heading",
  "hint": "GuidedTour-module__pyzSNW__hint",
  "navigation": "GuidedTour-module__pyzSNW__navigation",
  "primary": "GuidedTour-module__pyzSNW__primary",
  "spotlight": "GuidedTour-module__pyzSNW__spotlight",
  "tourPulse": "GuidedTour-module__pyzSNW__tourPulse",
});
